// Reducer for the Shortcuts

import * as ActionTypes from '../constants/action_types'
import { shortcutById } from './shortcutById_reducer'

export const DefaultShortcutsState = {
  byId: {},
  preference: 'media'
}

export const shortcuts = (state = DefaultShortcutsState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_SHORTCUT:
    case ActionTypes.REQUEST_SHORTCUT_FAILURE:
    case ActionTypes.RECEIVE_SHORTCUT:
    case ActionTypes.INVALIDATE_SHORTCUT:
      if (action.shortcutId) {
        return {
          ...state,
          byId: {
            ...state.byId,
            [action.shortcutId]: shortcutById(state.byId[action.shortcutId], action)
          }
        }
      } else {
        console.warn('Shortcut action fired without a shortcut id:', action)
        return state
      }
    case ActionTypes.SHORTCUT_AUDIENCE_PREFERENCE:
      return {
        ...state,
        preference: action.preference
      }
    default:
      return state
  }
}
